import React from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { AccordionLogic, useStyles, PropTypes } from './accordions.module';
const Accordions = (accordion) => {
  const classes = useStyles();
  const { current, changeState, values, translator, children } =
    AccordionLogic(accordion);

  return (
    <Accordion
      elevation={0}
      classes={{ root: classes.MuiAccordionroot }}
      expanded={current === 0}
      onChange={changeState(0)}
      TransitionProps={{
        timeout: 300,
        unmountOnExit: true,
      }}
    >
      <AccordionSummary
        className={classes.root}
        expandIcon={
          current === 0 ? (
            <RemoveCircleOutlineIcon
              className={classes.removeCircleOutlineIcon}
              fontSize="medium"
            />
          ) : (
            <AddCircleOutlineIcon
              className={classes.addCircleOutlineIcon}
              fontSize="medium"
            />
          )
        }
        aria-controls={values.ariaControls}
        id={values.id}
      >
        <Typography variant="h5" className={classes.questions}>
          {translator(`${values.questions}`)}
        </Typography>
      </AccordionSummary>

      <AccordionDetails style={{ display: 'block', padding: '0 24px 16px' }}>
        {values.answers && (
          <Typography variant="body1" className={classes.answers}>
            {translator(`${values.answers}`)}
          </Typography>
        )}

        {values.answers1 && (
          <div style={{ marginTop: values.answers ? '12px' : 0 }}>
            {values.id === 2 ? (
              <Link className={classes.link} to="/restore">
                <Typography
                  variant="body1"
                  className={classes.answers}
                  dangerouslySetInnerHTML={{
                    __html: translator(`${values.answers1}`),
                  }}
                />
              </Link>
            ) : (
              <Typography variant="body1" className={classes.answers}>
                {translator(`${values.answers1}`)}
              </Typography>
            )}
          </div>
        )}

        {values.answers2 && (
          <div
            style={{
              marginTop: values.answers || values.answers1 ? '12px' : 0,
            }}
          >
            <Typography variant="body1" className={classes.answers}>
              {translator(`${values.answers2}`)}
            </Typography>
          </div>
        )}

        {values.id === 2 && children && (
          <div style={{ marginTop: '16px' }}>{children}</div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
Accordions.propTypes = {
  ariaControls: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  questions: PropTypes.string,
  answers: PropTypes.string,
  answers1: PropTypes.string,
  answers2: PropTypes.string,
};

export default Accordions;
